import React, { Component } from 'react';
import { Modal, Header, Button, Grid, Icon, Segment } from 'semantic-ui-react'
import { Formik, Field, Form, select } from 'formik';
import ReadAxios from '../axiosComponent/readAxios'
import * as Yup from 'yup';
export default class UserModal extends Component {

    state = {
        editing: false,
    }

    getData = () => {
        ReadAxios({
            masterURL: `${process.env.REACT_APP_MAIN_URL}/masters/designationMaster/`,
            method: "get"
        }).then((res) => {
            if (res?.status === 200) {
                // this.props.getDesignationData(res.data.resultSet)
                this.setState({
                    rowItems: res?.data?.resultSet || [],
                    isLoaded: true,
                })
            }
            else {
                this.setState({
                    rowItems: [],
                    isLoaded: true,
                })
            }
        })
    }

    getDesignation() {
        return this.state.rowItems?.length ? this.state.rowItems?.map((o, i) => {
            const { designationId, designationCode } = o
            return (
                <option key={i} value={`${designationId},${designationCode}`} label={designationCode} />
            )
        }) : [];
    }


    componentDidMount() {
        this.getData()
    }
    // getSnapshotBeforeUpdate(props) {
    //     if (props.editUserDetails != null) {
    //         this.setState({ open: true })
    //     }
    // }
    render() {
        // console.log(this.props)
        let email_format = '^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$';
        const ValidationSchema = Yup.object().shape({
            realName: Yup.string()
                .min(2, 'Too Short!')
                .max(50, 'Too Long!')
                .required('Required'),
            mobileNo: Yup.number()
                .typeError('Please enter a valid mobile number')
                .min(9999999, 'Please enter a valid phone number')
                .max(9999999999, 'Please enter a valid phone number')
                .required('Required'),
            email: Yup.string()
                .matches(email_format, 'Please enter a valid email id')
                .required('Required'),
            designation: Yup.string()
                .required('Required')
        });
        return (
            <div>
                <Modal
                    size="large"
                    /*eslint-disable*/
                    onClose={this.props.onClose}
                    onOpen={this.props.onOpen}
                    open={this.props.open}
                    trigger={<Button type="button" size="mini" onClick={this.props.openUserModal} color="blue" basic className="w3-text-white" icon><Icon name="plus" /> New</Button>}
                >
                    <Header>Add User Details</Header>
                    <Modal.Content>
                        <Modal.Description>
                            <Formik
                                initialValues={{
                                    realName: this.props.mode == 'edit' ? this.props.editUserDetails?.realName : '',
                                    mobileNo: this.props.mode == 'edit' ? this.props.editUserDetails?.mobileNo : '',
                                    email: this.props.mode == 'edit' ? this.props.editUserDetails?.email : '',
                                    designation: this.props.mode == 'edit' ? `${this.props.editUserDetails?.designation},${this.props.editUserDetails?.designationCode}` : '',
                                    id: this.props.mode == 'edit' ? this.props.editUserDetails?.id : '',
                                }}
                                validationSchema={ValidationSchema}
                                onSubmit={(values) => {
                                    let data = (JSON.stringify(values, null, 2));
                                    let users = []
                                    users = JSON.parse(data)
                                    // console.log("json data : ", user_data)
                                    if (this.props.mode == 'edit') {
                                        this.props.getEditUserData(users, true)
                                    } else {
                                        this.props.getuserdata([users], true)
                                    }
                                    // this.setState({ open: false })
                                }}
                            >

                                {({ values, errors, touched, handleSubmit, handleChange, handleBlur, handleReset }) => (
                                    <React.Fragment>
                                        <Segment>
                                            <Grid.Row>
                                                <div className="col-6">
                                                    <label className="tiny ui form form-label">Name *</label>
                                                    <Field className="field-class" name="realName" />
                                                    {errors?.realName && touched?.realName ? (
                                                        <div className="p-10 w3-text-red">{errors?.realName}</div>
                                                    ) : null}

                                                    <br />

                                                    <label className="tiny ui form form-label mt-3">Email *</label>
                                                    <Field className="mt-3 field-class" id="email" name="email" />
                                                    {errors?.email && touched?.email ? <div className="p-10 w3-text-red">{errors?.email}</div> : null}

                                                    <br />

                                                </div>
                                                <div className="col-6">
                                                    <label className="tiny ui form form-label">Mobile No. *</label>
                                                    <Field className="field-class" id="mobileNo" name="mobileNo" />
                                                    {errors?.mobileNo && touched?.mobileNo ? (
                                                        <div className="p-10 w3-text-red">{errors?.mobileNo}</div>
                                                    ) : null}

                                                    <br />

                                                    <label className="tiny ui form form-label mt-3">Designation *</label>
                                                    <select
                                                        className="field-class mt-3"
                                                        name="designation"
                                                        value={values?.designation}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                    >
                                                        <option value={this.props.mode == 'edit' ? `${this.props.editUserDetails?.designation},${this.props.editUserDetails?.designationCode}` : ""} label={this.props.mode == 'edit' ? this.props.editUserDetails?.designationCode : "Select a designation"} />
                                                        {this.getDesignation()}

                                                    </select>
                                                    {errors?.designation && touched?.designation ? (
                                                        <div className="p-10 w3-text-red">{errors?.designation}</div>
                                                    ) : null}

                                                    <br />

                                                </div>
                                            </Grid.Row>
                                        </Segment>
                                        <center><Button type="submit" onClick={handleSubmit} className="m-2 mt-4" primary size="mini">Save</Button>
                                            <Button type="button" className="m-2 mt-3" onClick={this.props.onClose} size="mini">Close</Button>
                                        </center>
                                    </React.Fragment>
                                )}
                            </Formik>
                        </Modal.Description>
                    </Modal.Content>
                </Modal>
            </div>
        );

    }
}